import { Stores, News } from "../types";
import { makeAutoObservable } from "mobx";
import api from "../services/api";

export class ArticleStore {
  stores: Stores;

  articles: News[] = [
    {
      id: 1,
      title: "Titolo1",
      description: "Titolo1",
      authorID: "Bepi",
      image: "",
      createAt: new Date(),
      categoryID: "Titolo1",
    },
    {
      id: 2,
      title: "Titolo2",
      description: "Titolo2",
      authorID: "Caio",
      image: "",
      createAt: new Date(),
      categoryID: "Titolo2",
    },
    {
      id: 3,
      title: "Titolo3",
      description: "Titolo3",
      authorID: "Sanpronio",
      image: "",
      createAt: new Date(),
      categoryID: "Titolo3",
    },
  ];

  isLoading = false;

  clientsFilters: {
    [dataKey: string]: string | string[];
  } = {};

  constructor(stores: Stores) {
    this.stores = stores;

    makeAutoObservable(this);
  }

  getArticles = async () => {
    this.isLoading = true;
    try {
      let articles = await api.getArticles();
      this.articles = articles;
    } catch (err) { 
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  addArticle = async (data: Partial<News>) => {
    this.isLoading = true;
    try {
      // let articles = await api.addArticle();
      // this.articles.unshift(articles);
    } catch (err) { 
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  updateArticle = async (data: Partial<News>) => {
    this.isLoading = true;
    try {
      // let articles = await api.updateArticle();
      // this.articles = this.articles.map((article) =>
      //   article.id === article.id ? article : null
      // );
    } catch (err) { 
      throw err;
    } finally {
      this.isLoading = false;
    }
  };

  deleteArticle = async (data: Partial<News>) => {
    this.isLoading = true;
    try {
      // let articles = await api.deleteArticle();
      // this.articles = this.articles.filter((article) => "");
    } catch (err) { 
      throw err;
    } finally {
      this.isLoading = false;
    }
  };
}
